import { WindowLocation } from "@reach/router";

export default function isVehicleDetailPage(location: WindowLocation) {
    return location.pathname.startsWith("/detail");
}
